(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/single-rows.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/single-rows.js'); 
'use strict';

svs.tipset.views.SingleRows = Backbone.Marionette.View.extend({
  activeSegment: 0,
  regions: {
    matchList: '#single-matchlist',
    boards: '#boards',
    bomben: '#single-powerplay-bomben',
    drawSelector: '#drawChooser',
    actionbar: '#actionbar-content'
  },
  ui: {
    singleBoardsContainer: '.single-boards-container',
    clearAll: '.js-single-rows-clear-all'
  },
  events: {
    'click @ui.clearAll': 'clearAll'
  },
  singleMatchCollection: [],
  windowResize: null,
  initialize: function(params) {
    this.listenTo(svs.tipset.models.wager, 'scrollToStart', this.scrollToStart);
    $('.tips-usign-btn').remove();
    $('body').removeClass(
      'bg-oddset-500 bg-stryktipset-500 bg-europatipset-500 bg-extratipset-500 bg-topptipset-200'
    );

    var self = this;

    this.options = params;
    this.coupon = this.options.coupon;
    this.snapSize = 108;
    this.product = params.product;
    this.updateHeight = this.updateHeight.bind(this);
    this.scrollbarWidth = this.getScrollbarWidth();

    if (svs.core.detect.feature('ft-betslip')) {
      $('.tipset-betslipoverview-dimmer').removeClass(
        'no-transition tipset-betslipoverview-dimmer-visible'
      );
      this.addRegion('betslipRegion', '#betslip-wrapper');
      this.windowResize = function() {
        self.swiper.resize();

        self.updateHeight();

        var boardHeight = $('.board-wrapper').height();
        $('.singlerows-board-border').css('height', boardHeight);

        if (window.matchMedia('(min-width: 1024px)').matches) {
          $('.single-right-column').css('minHeight', boardHeight);
        } else {
          $('.single-right-column').removeAttr('style');
        }
        if (
          $('.js-slider-wrapper').width() >
          self.ui.singleBoardsContainer.width()
        ) {
          self.leftArrow.css({
            left: 10,
            top: boardHeight / 2
          });
          self.rightArrow.css({
            right: 10,
            top: boardHeight / 2
          });
        } else {
          self.arrows.addClass('hide-arrow');
        }
      };
    } else {
      this.windowResize = function() {
        self.swiper.resize();

        self.updateHeight();

        if (
          $('.js-slider-wrapper').width() >
          self.ui.singleBoardsContainer.width()
        ) {
          var navMenu = $('.js-navigation-menu'),
            windowWidth = $(window).width(),
            iconWidth = 40,
            navWidth = navMenu.width();

          if (navMenu.css('visibility') === 'hidden') {
            navWidth = 0;
          }

          self.leftArrow.css(
            'left',
            self.ui.singleBoardsContainer.offset().left - navWidth
          );
          self.rightArrow.css(
            'left',
            windowWidth - navWidth - iconWidth - self.scrollbarWidth
          );
        } else {
          self.arrows.addClass('hide-arrow');
        }
      };
    }

    var draw = svs.tipset.collections.draws.getCurrentDraw();
    var matches = new Backbone.Collection(draw.get('drawEvents'));

    this.singleMatchCollection = new svs.tipset.views.SingleMatchList({
      collection: matches
    });

    window.addEventListener('resize', this.windowResize);
  },

  updateHeight: function() {
    this.el.style.height =
      window.innerHeight - $('#top-content').height() + 'px';
    this.el.style.overflowY = 'auto';
    this.el.style.overflowX = 'hidden'; 
  },

  getScrollbarWidth: function() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'scrollbar-measure';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth =
      scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  },

  scrollToStart: function() {
    this.swiper.scrollTo(0, 0);
  },

  template: function(data) {
    return svs.tipset.templates.single_rows(data);
  },

  onAttach: function() {
    if (
      !_.isUndefined(this.options.drawNumber) &&
      !_.isUndefined(this.options.matchId)
    ) {
      this.showRegularMatchView();
    }

    this.leftArrow = $('.singlerows-swipe-arrow-left');
    this.rightArrow = $('.singlerows-swipe-arrow-right');
    this.arrows = $('.singlerows-swipe-arrow');

    var swipeWrap = document.getElementsByClassName('js-slider-container')[0],
      self = this;

    this.addDrawSelector();
    this.addMatches();
    this.addBoards();

    if (this.product === 'powerplay') {
      var hasMarketPlaceAccount =
          svs.components.marketplace &&
          svs.components.marketplace.accountSelector,
        isMarketPlaceAccount =
          hasMarketPlaceAccount &&
          svs.components.marketplace.accountSelector.helpers.getCurrentAccount();

      if (hasMarketPlaceAccount) {
        self.updateBombenButton = self.updateBombenButton.bind(self);
        svs.components.marketplace.accountSelector.helpers.observer.subscribe(
          self.updateBombenButton
        );
      }

      if (!isMarketPlaceAccount) {
        this.addBomben();
      }
    }
    svs.tipset.views.actionbar = new svs.tipset.views.TipsenActionbar({
      model: new svs.tipset.models.TipsetActionbar()
    });

    if (!svs.core.detect.feature('ft-betslip')) {
      var navWidth = $('.js-navigation-menu').width();
      self.leftArrow.css(
        'left',
        self.ui.singleBoardsContainer.offset().left + navWidth
      );
      self.rightArrow.css(
        'left',
        self.ui.singleBoardsContainer.offset().left +
          self.ui.singleBoardsContainer.width() +
          navWidth -
          40
      );
    } else {
      $('#singleCouponTopLeft').addClass('tabs-' + this.product);
      $('.drawChooser-wrapper').addClass('tabs-tabs');
    }
    this.addContextualMenu();

    var swiperObj = new svs.components.Slider(swipeWrap, {
        bouncing: true,
        slideOnDrag: false
      }),
      slideWrapper = $('.js-slider-wrapper');

    this.swiper = swiperObj;
    slideWrapper.css('width', 1306);
    if (slideWrapper.width() > this.ui.singleBoardsContainer.width()) {
      $(this.arrows[1]).removeClass('hide-arrow');
      this.arrows.click(function() {
        var numberOfRows = Math.floor(
          self.ui.singleBoardsContainer.width() / self.snapSize
        );

        swiperObj.scrollTo(
          swiperObj.getCurrentSlideIndex() +
            ($(this).hasClass('singlerows-swipe-arrow-right')
              ? numberOfRows
              : numberOfRows * -1)
        );
      });

      swiperObj.on('reachedend', this.reachedendListener.bind(this));
      swiperObj.on('reachedstart', this.reachedstartListener.bind(this));
      swiperObj.on('scrollstart', this.scrollstartListener.bind(this));
    }

    setTimeout(function() {
      swiperObj.resize();
      self.windowResize();
    }, 200);
    this.updateHeight();
  },

  showRegularMatchView: function() {
    var couponColumn = $('#couponColumn'),
      currentCompetitionUrl = svs.tipset.models.competition
        ? svs.tipset.models.competition.currentCompetitionUrl()
        : '';

    if (couponColumn) {
      couponColumn.show();
    }

    if (currentCompetitionUrl == '') {
      svs.tipset.models.header.resetCenter();
    }

    if (this.product === 'powerplay') {
      this.getRegion('bomben').show(
        new svs.tipset.views.BombenButton({
          model: svs.tipset.models.bombenXperten
        })
      );
    }
  },

  onClose: function() {
    var swiper = this.swiper;
    if (swiper) {
      swiper.off('reachedend', this.reachedendListener);
      swiper.off('reachedstart', this.reachedstartListener);
      swiper.off('scrollstart', this.scrollstartListener);
    }
    if (this.drawSelector) {
      this.drawSelector.destroy();
    }

    window.removeEventListener('resize', this.windowResize);

    $('#uSignRow').append(
      '<div id="uSignsBtn" class="col-sm-6 col-md-4 col-lg-3 col-lg-4 col-xl-3 tips-usign-btn"></div>'
    );
  },

  onDestroy: function() {
    this.onClose();
  },

  reachedendListener: function() {
    $(this.arrows[1]).addClass('hide-arrow');
    $(this.arrows[0]).removeClass('hide-arrow');
  },
  reachedstartListener: function() {
    $(this.arrows[0]).addClass('hide-arrow');
    $(this.arrows[1]).removeClass('hide-arrow');
  },
  scrollstartListener: function() {
    $(this.arrows[1]).removeClass('hide-arrow');
    $(this.arrows[0]).removeClass('hide-arrow');
  },

  changeRound: function(drawNum) {
    var drawUrlAddOn = svs.tipset.collections.draws
      .getDrawById(drawNum)
      .get('urlAddOn');

    svs.tipset.collections.draws.setCurrentDraw(drawUrlAddOn);

    var gotoUrl = 'spela/' + drawUrlAddOn;

    if (!svs.core.detect.formfactor.mobile()) {
      gotoUrl += '/1';
    }

    Backbone.history.navigate(gotoUrl, { trigger: true, replace: true });

    return false;
  },

  addDrawSelector: function() {
    var self = this,
      drawselectorOptions = {
        callback: function(drawNum) {
          self.changeRound(drawNum);

          if (
            svs.components.marketplace &&
            svs.components.marketplace.accountSelector
          ) {
            var observerHelpers =
              svs.components.marketplace.accountSelector.helpers.observer;

            self.updateMarketplaceAccountSelector();
            observerHelpers.clearSubscriptions();
          }
        },
        draws: svs.tipset.collections.draws.getAllDraws(),
        currentDraw: this.options.drawNumber,
        branding: svs.tipset.models.gameDefinitions.get('htmlClass'),
        swiperUpdateFunction: this.updateSwiper
      };
    this.getRegion('drawSelector').show(
      new svs.sport.drawselector.views.Drawselector(drawselectorOptions)
    );
  },

  updateMarketplaceAccountSelector: function() {
    svs.components.marketplace.accountSelector.helpers.fetchGames({
      drawNumber: svs.tipset.collections.draws
        .getCurrentDraw()
        .get('drawNumber'),
      productId: svs.tipset.collections.draws.getCurrentDraw().get('productId')
    });
  },

  addBoards: function() {
    this.getRegion('boards').show(
      new svs.tipset.views.SingleBoards({
        collection: svs.tipset.collections.boardCollections
      })
    );
  },

  addContextualMenu: function() {
    if (svs.utils.initContextMenu) {
      svs.utils.initContextMenu();
    }
  },

  addMatches: function() {
    this.getRegion('matchList').show(this.singleMatchCollection);
  },

  clearAll: function() {
    var self = this;

    svs.tipset.views.contextualmenu.onRensaTecken(function() {
      self.el.scrollTo(0, 0);
    });
  },

  addBomben: function() {
    var matchCollection = this.singleMatchCollection;
    this.getRegion('bomben').show(
      new svs.tipset.views.BombenButton({
        model: new svs.tipset.models.BombenButton({
          hasBomben: matchCollection.hasBomben()
        })
      })
    );
  },

  updateBombenButton: function(ref) {
    if (ref.currentAccount) {
      if (this.getRegion('bomben').hasView()) {
        this.getRegion('bomben').empty();
      }
    } else {
      if (!this.getRegion('bomben').hasView()) {
        this.addBomben();
      }
    }
  }
});

 })(window);